import { z } from 'zod';
const maxPostgresPositiveBigInt = '9223372036854775807';
/** Canonical positive PostgreSQL BIGINT, kept on the wire as a decimal string. */
export const membershipEpochGuard = z
    .string()
    .min(1)
    .max(maxPostgresPositiveBigInt.length)
    .regex(/^[1-9]\d*$/)
    .refine((value) => value.length < maxPostgresPositiveBigInt.length || value <= maxPostgresPositiveBigInt);
